import type { ApiResponse, ListResult } from "~/types";
import type { EsAutoSuggestion } from "~/types/EsAutoSuggestion";
import type { EsProduct, EsProductRelatedInfo } from "~/types/SearchData";
import type { NitroFetchRequest, $Fetch } from 'nitropack'
export const searchRepository = () => ({

    // appended search because of proxy
    async searchAutoSuggestion(keyword: string) {
        return await useAPIFetch<ApiResponse<EsAutoSuggestion[]>>('/search/esSuggestion/suggest', {
            params: { keyword }, // Query parameter
        });
    },

    async recommend(id: number, pageNum?: number, pageSize?: number) {
        return await useAPIFetch<ApiResponse<ListResult<EsProduct>>>(`/search/esProduct/recommend/${id}`, {
            params: { pageNum, pageSize }, // Query parameters
        });
    },

    async searchRelatedInfo(keyword: string) {
        return await useAPISearch<ApiResponse<EsProductRelatedInfo>>('/esProduct/search/relate', {
            params: { keyword }, // Query parameter
        });
    },
});
